(function() {
    'use strict';

    angular.module('app.cantidades', []);
})();
